.header {
  display: flex;
  align-items: center;
  gap: 10px;
}
.body {
  padding: 0;
  width: max-content;
  max-width: min(1600px, 90vw);
  overflow: hidden;
}
.footer {
  display: flex;
  gap: 12px;
  justify-content: end;
}
.selectAllRow {
  display: flex;
  align-items: center;
  gap: 12px;
  border-bottom: 1px solid var(--static-divider-standard);
  padding: 16px;
}
.items {
  overflow: auto;
}
.item {
  display: flex;
  border-bottom: 1px solid var(--static-divider-standard);
  padding: 16px 16px 20px;
  cursor: pointer;
}
.item.error {
  background: var(--sentiment-background-negative);
}
.item.allAssigned {
  cursor: not-allowed;
  background: var(--sentiment-background-positive);
  opacity: var(--field-opacity-disabled);
}
.item.allAssigned * {
  pointer-events: none;
}
.item:last-child {
  border-bottom: none;
}
.spacer {
  flex: 1;
}
.boxType {
  display: flex;
  gap: 12px;
  padding-top: 24px;
}
.boxType .label {
  font-size: var(--fs-small);
  white-space: nowrap;
  padding-bottom: 6px;
}
.inlineInputs {
  display: flex;
  align-items: center;
  color: var(--static-text-weak);
}
.smallInput {
  width: 80px;
}
.icon {
  display: flex;
}
.oversized {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.errorText {
  color: var(--sentiment-text-negative);
  font-size: var(--fs-x-small);
  margin: 9px 0 -9px;
}
